import { useQuery } from "@tanstack/react-query";
import { getSawOverview } from "../repositories/sawOverviewRepository";
import { SawOverviewData } from "../models/types";

interface UseSawOverviewDataProps {
	assetId?: number | null;
	onError?: (error: Error) => void;
}

// Mirrors useOverviewData (weldlines) — same 10s cadence, same refetch policy.
export const useSawOverviewData = ({
	assetId = null,
	onError,
}: UseSawOverviewDataProps = {}) => {
	const { data, isLoading, refetch } = useQuery<SawOverviewData, Error>({
		queryKey: ["sawOverview", assetId],
		queryFn: () => getSawOverview(assetId),
		meta: { realtime: ["FAB.GetSawOverview"] },
		refetchInterval: 10000,
		refetchOnWindowFocus: true,
		onError,
	});

	return {
		data,
		isLoading,
		refetch,
	};
};
